import { apiAuth, apiResponseType } from ".";

export const getPositionsData = (
  page: number = 1,
  unity_id?: string,
  name?: string
): apiResponseType =>
  apiAuth.get(
    `positions?page=${page}${unity_id ? `&unity_id=${unity_id}` : ""}${
      name ? `&name=${encodeURIComponent(name)}` : ""
    }`
  );

export const registerPositionsData = (data) =>
  apiAuth.post("/positions/store", data) as apiResponseType;

export const deletePositionsData = (uuid: string) =>
  apiAuth.delete(`positions/${uuid}/destroy`) as apiResponseType;

export const updatePositionsData = (uuid: string, data) =>
  apiAuth.post(`positions/${uuid}/update`, data) as apiResponseType;

export const getShowPositions = (uuid: string) =>
  apiAuth.get(`positions/${uuid}/show`) as apiResponseType;

export const searchPositionsData = (params: {
  name: string;
  unity_id?: string;
}): apiResponseType =>
  apiAuth.get(
    `positions?name=${params.name}${
      params.unity_id ? `&unity_id=${params.unity_id}` : ""
    }`
  );

export const setStatusPositions = (uuid: string) =>
  apiAuth.put(`positions/${uuid}/toggle-status`) as apiResponseType;

export const getSelectPositions = (
  unity_id?: number | string,
  sector_id?: number | string
) => {
  const params = new URLSearchParams();
  if (unity_id) params.set("unity_id", String(unity_id));
  if (sector_id) params.set("sector_id", String(sector_id));
  const query = params.toString();
  return apiAuth.get(
    `positions/select${query ? `?${query}` : ""}`
  ) as apiResponseType;
};
